export const LOCALE_DEVTOOL = {
    NONE: 'NONE',
    ID: 'ID',
    EMPTY: 'EMPTY',
};
/**
 * Test if value is MessageDescriptor which may be passed to react-int methods
 */
export function isMessageDescriptor(value) {
    return value && typeof value === 'object' && typeof value.id === 'string' && value.id;
}
//# sourceMappingURL=types.js.map